var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"query"},[_c('div',{staticClass:"query__title"},[_vm._v("商务微信")]),_c('div',{staticClass:"query__content"},[_c('el-card',{staticClass:"query__text"},[_c('img',{attrs:{"src":"/images/wx.png"}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }